var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"tile":"","flat":""}},[_c('page-container',[_c('v-container',{staticClass:"pa-6 d-flex justify-space-between align-center"},[_c('v-img',{staticClass:"flex-grow-0",attrs:{"src":require("../assets/logo.svg"),"width":"120"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }